import { jsx } from 'react/jsx-runtime';
import { IconButton, Persona, PersonaInitialsColor, PersonaSize } from '@fluentui/react';
import Tooltip from '../../../../../Tooltip/Tooltip.esm.js';
import { useTranslation } from 'react-i18next';
import { sharedClassNames } from '../../../styles.esm.js';

var iconButtonStyles = {
    rootDisabled: {
        backgroundColor: 'unset'
    }
};
var LoadingUserButton = function() {
    var t = useTranslation('header').t;
    var loadingUserText = t('Just a moment, logging you in...');
    return /*#__PURE__*/ jsx(Tooltip, {
        tooltipHostProps: {
            content: loadingUserText
        },
        children: /*#__PURE__*/ jsx(IconButton, {
            className: sharedClassNames.iconButton,
            disabled: true,
            styles: iconButtonStyles,
            ariaLabel: loadingUserText,
            children: /*#__PURE__*/ jsx(Persona, {
                size: PersonaSize.size32,
                hidePersonaDetails: true,
                imageAlt: loadingUserText,
                initialsColor: PersonaInitialsColor.coolGray
            })
        })
    });
};

export { LoadingUserButton as default };
